import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { Resource, Mutation, CoreLibService, Query } from 'core-lib';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MediaLibraryLibService {

  private subject = new BehaviorSubject<Resource[]>([]);
  private QUERY = gql`
    query GetResources{
      listResources{
        title
        creator
        url
        creationDate
        mimeType
        lastModificationDate
      }}`;

  private UPLOAD_QUERY = gql`
    mutation uploadFiles($files:[Upload]!){
      uploadResources(files: $files) {
        title
        creator
        url
        creationDate
        mimeType
        lastModificationDate
      }}`;

  getResources(): Observable<Resource[]> {
    return this.subject.asObservable();
  }

  uploadFiles(app: string, filesParam: any): Observable<Resource[]> {
    /*return this.apollo.mutate<Mutation>({
      mutation: this.UPLOAD_QUERY,
      variables: {
        files: filesParam
      },
      context: {
        useMultipart: true
      },
    }).pipe((map(value => value.data.uploadResources)));*/
    return null;
  }

  reload(): void {
    this.apollo.query<Query>({
      query: this.QUERY,
      variables: {}
    }).subscribe((result) => {
      this.subject.next(result.data.listResources);
    });
  }

  constructor(private coreLibService: CoreLibService, private apollo: Apollo) {
 
  }
}
